import { Injectable, Injector } from '@angular/core';
import { Platform } from '@ionic/angular';
import { AuthServiceService } from './auth-service.service';
import { Router } from '@angular/router';
import { FirestoreService } from '../services/firestore.service';

/*NOTIFICACIÓNES*/
import { LocalNotifications, LocalNotificationSchema, LocalNotificationsPlugin} from '@capacitor/local-notifications';
import { ActionPerformed, PushNotificationSchema, PushNotifications, Token} from '@capacitor/push-notifications';
import { AngularFireAuth } from '@angular/fire/compat/auth';


@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  constructor(public platform: Platform,
              private injector: Injector,
              public afsAuth: AngularFireAuth,
              private router: Router,
              private firestoreService: FirestoreService,
              ) {
                           
  }


  // Método público para disparar desde el login
iniciarNotificaciones() {
  const auth = this.injector.get(AuthServiceService);
  const userUid: string = auth.userData.uid;
  const tokenuid: string = auth.userData.token;
  this.inicializar(userUid, tokenuid);
}
  ngOnInit(): void { }

 

  inicializar(userUid: string, tokeuid: string){  
    if(this.platform.is('capacitor')){
      PushNotifications.requestPermissions().then(result => {
        if (result.receive  === 'granted') {
        //  console.log('Permisos consedidos :)')
          // Regístrese con Apple / Google para recibir push a través de APNS/FCM
          PushNotifications.register();
          this.listadePermisos(userUid, tokeuid)
        } else {
          // mostrar el error
        }
      });
    }else{
     // console.log('No es un movil')
    }
  }

  listadePermisos(userUid: string, tokeuid: string){

    LocalNotifications.registerActionTypes({
      types:[
        {
          id: 'ACCIONES_MSS',
          actions: [
            /*{
              id: 'view',
              title: 'Abrir',
            },
             {
              id: 'respond',
              title: 'Responder',
              input: true
            },*/
            {
              id: 'remove',
              title: 'Eliminar',
              destructive: true
            },

          ]
        }
      ]
    })

    //notificaciones locales
   /*LocalNotifications.schedule({  
      notifications: [
        {
          id: 1,
          title: 'Notificacion Manual',
          body: 'xxxxxxxxxxxxxxxxxxxxxxxx',
          smallIcon:'mascota.png',
          largeIcon:'notification_icon.png',
          //largeBody: "LargeBody",
          //summaryText: "summaryText",
          actionTypeId: "ACCIONES_MSS",
          sound: "sonido1", // No funciona a un

           //FUNCIONA SOLO EN IOS
          //attachments:[
            //{id: 'face', url:'mascota.png'}
          //],
          //schedule: { at: new Date(Date.now()) }, conflicto
        }
      ]
    })*/
    
   // En caso de éxito, deberíamos poder recibir notificaciones
    PushNotifications.addListener('registration',
      (token: Token) => {
     //   console.log('Push registration success, token=>', token.value);
        this.gardarToken(token.value, userUid, tokeuid);
      }
    );

    // Algún problema con nuestra configuración y empuje no funcionará
    PushNotifications.addListener('registrationError',
      (error: any) => {
        console.log('Error on registration: ', JSON.stringify(error));
      }
    );

    // Muéstranos la notificación en primer plano
    PushNotifications.addListener('pushNotificationReceived',
      (notification: PushNotificationSchema) => {
        
   //     console.log('Primer Plano: ', JSON.stringify(notification), '=>', notification.data.userImg);
        
        LocalNotifications.schedule({  
          notifications: [
            {
              id: 2,
              title: notification.title,
              body: notification.body,
              smallIcon:'mascota.png',
              largeIcon:'notification_icon.png',
              actionTypeId: "ACCIONES_MSS",
              //sound: "sonido1",
            }
          ]
        })

        this.router.navigate([notification.data.enlace])
        
      }
    );

     // Muéstranos la notificación en segundo plano
    PushNotifications.addListener('pushNotificationActionPerformed',
      (notification: ActionPerformed) => {
        console.log('Segundo Plano: ', JSON.stringify(notification), '=>', JSON.stringify(notification.notification.data.enlace));
        //agregar la ruta a donde va a ir la notificacion
        this.router.navigate([notification.notification.data.enlace])
      }
    );

    
    LocalNotifications.addListener('localNotificationActionPerformed', (payload) => {
      // triggers when the notification is clicked.
     // console.log('notification triggered:', payload);
    });

  }


  gardarToken(token: string,userUid: string, tokeuid: string){

      
    //console.log('Uusuario logeado - Uid =>', userUid, 'Token=>', token)
    
    if(token != tokeuid){

      const path = 'users/'
      
      var data = {
        token: token
      }

      this.firestoreService.actualizarDato(path, userUid, data).then(res =>{
       // console.log('Dato actualizado')
      }).catch(err => {
        console.log('Se presento un error', err.message)
      })
    }

  }




}

